export default __webpack_public_path__ + "static/media/antd.51586d6b.svg";